const e={small:24,medium:40,large:80};export{e as ICON_SIZE};
//# sourceMappingURL=constants.js.map
